(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/about', {
      templateUrl: 'modules/app/about/about.html',
      controller: 'AboutCtrl'
    });
  }]).
  /**
   * About Page
   */
  controller('AboutCtrl', ['$scope', 'Config', function ($scope, Config) {
    //set header
    $scope.$emit("headline:change", "About");
    $scope.$emit("nav:change", "about");
    $scope.buildInformation = Config.get().buildInformation;
  }]);
})();
